import { Pipe, PipeTransform } from '@angular/core';
import { InfoMessageSeverity } from '@shared/enums/infoMessageSeverity';

@Pipe({
    name: 'infoMessageIcon',
    standalone: false
})
export class InfoMessageIconPipe implements PipeTransform {

	transform(value: number): string {
		let tailwindClass: string;

		switch (value) {
			case InfoMessageSeverity.success: {
				tailwindClass = 'far fa-check-circle text-green-400';
				break;
			}
			case InfoMessageSeverity.info: {
				tailwindClass = 'fas fa-exclamation-circle text-yellow-400';
				break;
			}
			case InfoMessageSeverity.warning: {
				tailwindClass = 'far fa-times-circle text-red-400';
				break;
			}
			default: {
				tailwindClass = 'far fa-arrow-alt-circle-right text-red-400';
				break;
			}

		}

		return tailwindClass;
	}

}
